import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid, Typography, units } from '@hbf/dsl';
import { CheckCircleOutlinedIcon } from 'ha/ui/Icons';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

export interface Props {
  title: string;
  valuePropositions: string[];
}

const useStyles = makeStyles()(theme => ({
  title: {
    marginBottom: units.rem(1.5),
    [theme.breakpoints.up('md')]: {
      marginBottom: units.rem(2.5),
      textAlign: 'center',
    },
  },
  titleTemp: {
    textAlign: 'center',
    marginBottom: 0,
  },
  icon: {
    marginRight: units.rem(0.5),
  },
}));

export const VpChecklist: React.FC<Props> = ({ title, valuePropositions }) => {
  const { md } = useMediaQuery();
  const hideCheckmark =
    valuePropositions.length === 1 &&
    valuePropositions[0].toLowerCase() === 'remove by code';
  const { classes } = useStyles();
  return (
    <div>
      <Typography.H1
        component="h3"
        className={hideCheckmark ? classes.titleTemp : classes.title}
      >
        {title}
      </Typography.H1>
      <Grid container spacing={md ? 5 : 2}>
        {!hideCheckmark &&
          valuePropositions.map(vp => (
            <Grid item container wrap="nowrap" xs={12} md={4} key={vp}>
              <CheckCircleOutlinedIcon
                color="secondary"
                className={classes.icon}
              />
              <Typography.Paragraph data-test-locator="VpChecklist item">
                {vp}
              </Typography.Paragraph>
            </Grid>
          ))}
      </Grid>
    </div>
  );
};
